<template>
  <div class="drag-panel">
    <div :style="customStyle">
      <!-- 背景层 -->
      <div class="background-layer" :style="backgroundStyle"></div>
      <vue-drag
        v-for="item in dragList"
        :snap="true"
        :parent="true"
        :min-width="20"
        :key="item.iid"
        :snapTolerance="10"
        :x="item.position.x || 0"
        :y="item.position.y || 0"
        :z="item.position.z || 0"
        :w="item.position.w || 'auto'"
        :h="item.position.h || 'auto'"
        :draggable="false"
        :resizable="false"
        :active="false"
        class-name="custome-drag"
      >
        <Echarts
          :key="item.iid + count"
          :ref="item.iid"
          :iid="item.iid"
          :chartType="item.components"
          :customChartData="item.components === 'CustomChartConfig' ? item.data : []"
          :customChartJs="item.components === 'CustomChartConfig' ? item.jsTxt : ''"
          :option="item.option"
          :position="item.position"
          v-if="item.components.indexOf('ChartConfig') != -1"
        />
        <Texts v-if="item.components === 'TextConfig'" :option="item.option" :position="item.position" />
        <Picture v-if="item.components === 'PicConfig'" :option="item.option" :position="item.position" />
        <Iframe v-if="item.components === 'IframeConfig'" :option="item.option" :position="item.position" :title="''" />
        <Tabs :ref="item.iid" v-if="item.components === 'TabsConfig'" :option="item.option" :position="item.position" />
        <NavList v-if="item.components === 'NavListConfig'" :option="item.option" :position="item.position" />
        <FlipNumber
          :ref="item.iid"
          v-if="item.components === 'FlipperConfig'"
          :option="item.option"
          :position="item.position"
        />
        <List :ref="item.iid" v-if="item.components === 'ListConfig'" :option="item.option" :position="item.position" />
        <PercentageIndicator
          :ref="item.iid"
          v-if="item.components === 'PercentageIndicatorConfig'"
          :option="item.option"
          :position="item.position"
        />
        <CircularProgressBar
          :ref="item.iid"
          v-if="item.components === 'CircularProgressBarConfig'"
          :option="item.option"
          :position="item.position"
        />
        <HorizontalProgressBar
          :ref="item.iid"
          v-if="item.components === 'HorizontalProgressBarConfig'"
          :option="item.option"
          :position="item.position"
        />
        <DatePicker
          :ref="item.iid"
          v-if="item.components === 'DatePickerConfig'"
          :option="item.option"
          :position="item.position"
          @changeDate="onChangeDate"
        />
        <PlacePicker
          :ref="item.iid"
          v-if="item.components === 'PlacePickerConfig'"
          :option="item.option"
          :position="item.position"
          @changePlace="onChangePlace"
        />
        <TimeNow
          :ref="item.iid"
          v-if="item.components === 'TimeNowConfig'"
          :option="item.option"
          :position="item.position"
        />
      </vue-drag>
    </div>
    <!-- 机器人头像 -->
    <img
      v-if="robotConfig.openWenshu && !robotConfig.openZnhd && resultText === ''"
      :src="robotConfig.logoUrl ? robotConfig.logoUrl : ImgRobot"
      alt=""
      class="robot-img"
      @click="goRobot()"
    />
    <!-- 小程序进入后的语音输入框 -->
    <!-- <div class="voice-input" v-if="robotConfig.openWenshu && robotConfig.openZnhd && question !== ''">
      {{ question }}
      <img class="voice-img" :src="ImgVoice" alt="" />
    </div> -->
    <!-- 二维码 -->
    <div class="qrcode-img" v-if="robotConfig.openWenshu && robotConfig.openZnhd">
      <div v-if="refreshQr" class="qr-mask">
        <a-icon type="redo" style="font-size:28px;color:#1890ff;" @click="refreshQrCode" :spin="loadingQr" />
      </div>
      <img :src="qrcodeUrl" alt="" />
    </div>
    <!-- 可拖拽的问答窗口 -->
    <robot-modal
      ref="robotModal"
      :isTalking="isTalking"
      :showInput="robotConfig.openWenshu && robotConfig.openZnhd && question !== ''"
      :visible="robotConfig.openWenshu && robotConfig.openZnhd && resultText !== ''"
      :width="robotConfig.width"
      :height="robotConfig.height"
      :backgroundColor="robotConfig.backgroundColor"
      :fontColor="robotConfig.fontColor"
      :fontSize="robotConfig.fontSize"
      :borderColor="robotConfig.borderColor"
      :type="'overview'"
      :question="question"
      :resultText="resultText"
    ></robot-modal>
  </div>
</template>

<script>
import { VueDrag } from '@/components'
import { JDATA_API } from '@/api'
import { timingTask } from '@/utils/timer'
import { getUrlParam, getWindowParam } from '@/utils/fns'
import RobotModal from './components/RobotModal.vue'
import WebSocketClient from '@/utils/socketwechat'
// import china from '@/components/config/china.json'
import {
  Picture,
  Texts,
  Tabs,
  NavList,
  Iframe,
  Echarts,
  FlipNumber,
  List,
  CircularProgressBar,
  PercentageIndicator,
  HorizontalProgressBar,
  DatePicker,
  PlacePicker,
  TimeNow
} from '@/common'
import { cloneDeep, isEmpty } from 'lodash'
import Socket from '@/utils/socket'
import ImgRobot from '@/assets/robot.png'
import ImgVoice from '@/assets/voice.png'
import QRCode from 'qrcode'
import { sseAPI } from '@/api/sse.js'

export default {
  name: 'ShowPageDetail',
  filters: {},
  components: {
    Picture,
    Texts,
    Tabs,
    Iframe,
    NavList,
    VueDrag,
    Echarts,
    FlipNumber,
    List,
    PercentageIndicator,
    CircularProgressBar,
    HorizontalProgressBar,
    DatePicker,
    PlacePicker,
    TimeNow,
    RobotModal
  },
  data() {
    return {
      ImgRobot,
      ImgVoice,
      count: 0,
      iid: '',
      convertRoute: null,
      loading: false,
      pageConfig: {},
      page: {},
      regionId: '',
      cTime: '',
      qrcodeUrl: '', //二维码地址
      robotConfig: {}, //问数机器人配置
      question: '', //小程序发送的问题
      resultText: '', //机器人回答的结果
      isTalking: false, //是否正在问答中
      webchatToken: '', //小程序token
      wsClient: null,
      sseClient: null, // SSE客户端
      chatId: '',
      modelId: '', //问答模型id
      robotUrl: '', //跳转的机器人地址
      qrCodeTimer: null, // 二维码计时器
      refreshQr: false,
      loadingQr: false,
      closeRobotTimer: null, //关闭小窗的定时器
      wechatUrl: '' //小程序前缀地址
    }
  },
  props: {
    // host: {
    //   type: String,
    //   default: null,
    //   required: true
    // }
  },
  activated() {},
  created() {
    const _this = this
    JDATA_API.getHost()
      .then(res => {
        if (res.success && res?.data?.contextPath) {
          Socket.init({ host: res.data.contextPath, userId: 'detail' }, res => {
            _this.convertRoute = res
          })
        }
      })
      .catch(err => {
        console.log('err: ', err)
      })
    // const iid = this.$route?.params?.id
    // console.log('地址栏参数', window.location.search.slice(window.location.search.lastIndexOf('?') + 1))
    // const newId = getUrlParam('id')
    let newId = ''
    if (window.jdataParams) {
      if (getWindowParam('id').indexOf('-') !== -1) {
        newId = this.$root.jcms_id
      } else {
        newId = getUrlParam('id')
      }
    } else {
      newId = getUrlParam('id')
    }
    // if (getUrlParam('id').indexOf('-') !== -1) {
    //   newId = this.$root.jcms_id
    // } else {
    //   newId = getUrlParam('id')
    // }
    // const newId = this.$root.jcms_id
    if (newId) {
      // this.getPageDetail(newId)
      this.regionId = getUrlParam('regionCode')
      this.getPageDetail(newId)
    }
  },
  watch: {
    convertRoute: {
      handler: function(newVal) {
        // if (newVal?.oldPageId === this.$route?.params?.id) {
        //   // console.log('123')
        //   this.$router.push({ path: `/page/detail/${newVal.newPageId}` })
        // }
        const newId = getUrlParam('id')
        if (newVal?.newPageId !== newId) {
          window.location.replace(window.location.href.split('?')[0] + `?page=page&type=detail&id=${newVal.newPageId}`)
        }
      },
      deep: true
    }
    // eslint-disable-next-line no-unused-vars
    // $route(to, from) {
    //   // 路由发生变化页面刷新
    //   this.$router.go(0)
    // }
  },
  mounted() {},
  computed: {
    customStyle() {
      const customWH = this.pageConfig?.page?.customizeWH
      if (customWH?.height) {
        return {
          height: `${customWH.height}px`,
          width: `${customWH.width}px`,
          position: 'relative'
        }
      } else {
        return { height: '1080px', width: '1920px', position: 'relative' }
      }
    },
    backgroundStyle() {
      const backgroundStyle = this.pageConfig?.page?.backgroundStyle
      return (
        backgroundStyle || {
          backgroundColor: '#ffffff',
          backgroundImage: '',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      )
    },
    dragList() {
      const { dragList } = this.pageConfig
      for (let i = 0; i < dragList?.length; i++) {
        let item = dragList[i]
        if (item?.components?.indexOf('ChartConfig') !== -1) {
          if (item?.config?.dataOption !== 3) {
            this.setDataInterval(item, i, true)
          }
        }
        if (
          [
            'ListConfig',
            'TextConfig',
            'FlipperConfig',
            'PercentageIndicatorConfig',
            'CircularProgressBarConfig',
            'HorizontalProgressBarConfig'
          ].includes(item?.components)
        ) {
          if (item?.config?.dataOption !== 3) {
            this.$nextTick(() => {
              this.setDataInterval(item, i, false)
            })
          }
        }
      }
      return dragList || []
    }
  },
  methods: {
    // 设置实时查询数据
    setDataInterval(item, index, type) {
      const iid = item.iid
      // const pageId = this.$route.params.id
      // const newId = getUrlParam('id')
      // const newId = this.$root.jcms_id
      let newId = ''
      if (window.jdataParams) {
        if (getWindowParam('id').indexOf('-') !== -1) {
          newId = this.$root.jcms_id
        } else {
          newId = getUrlParam('id')
        }
      } else {
        newId = getUrlParam('id')
      }
      // if (getUrlParam('id').indexOf('-') !== -1) {
      //   newId = this.$root.jcms_id
      // } else {
      //   newId = getUrlParam('id')
      // }
      this.iid = newId
      // var a = window.location.search.slice(window.location.search.lastIndexOf('?') + 1)
      // if (a.indexOf('&') != -1) {
      //   var str = a.split('=')
      //   const iid = str[1]
      //   var c = iid.split('&')
      //   this.iid = c[0]
      // } else {
      //   var b = a.split('=')
      //   this.iid = b[1]
      // }
      // const param = this.$route.query.param
      const param = getUrlParam('param')

      const params = {
        dataId: iid,
        pageId: this.iid,
        param: param,
        index: index,
        areaCode: this.regionId,
        ctime: this.cTime
      }
      // const params = {
      //   dataId: iid,
      //   pageId: pageId,
      //   param: param,
      //   index: index
      // }
      const config = {
        interval: 1, // 间隔天数，间隔为整数
        runNow: true, // 是否立即运行
        time: '01:00:00' // 执行的时间点 时在0~23之间
      }
      // 查询间隔 1:只取一次 2:每晚一点 3:每5s
      // 查询间隔 1:只取一次 2:每晚一点 3:每分钟 4:每小时 5:每5分钟 6:每10分钟 7:每半小时
      const interval = item.config.interval
      switch (interval) {
        case 1:
          // if (param) {
          if (type) {
            this.getPageData(params)
            // console.log('只取一次', interval, '图表')
          } else {
            this.getData(params)
            // console.log('只取一次', interval, '其他')
          }
          // }
          break
        case 2:
          if (type) {
            item.config.timer = timingTask(config, this.getPageData, params)
          } else {
            item.config.timer = timingTask(config, this.getData, params)
          }
          break
        case 3:
          // if (param) {
          if (type) {
            this.getPageData(params)
          } else {
            this.getData(params)
          }
          // }
          item.config.timer = setInterval(() => {
            if (type) {
              this.getPageData(params)
            } else {
              this.getData(params)
            }
          }, 60 * 1000)
          break
        case 4:
          // if (param) {
          if (type) {
            this.getPageData(params)
          } else {
            this.getData(params)
          }
          // }
          item.config.timer = setInterval(() => {
            if (type) {
              this.getPageData(params)
            } else {
              this.getData(params)
            }
          }, 60 * 60 * 1000)
          break
        case 5:
          // if (param) {
          if (type) {
            this.getPageData(params)
          } else {
            this.getData(params)
          }
          // }
          item.config.timer = setInterval(() => {
            if (type) {
              this.getPageData(params)
            } else {
              this.getData(params)
            }
          }, 5 * 60 * 1000)
          break
        case 6:
          // if (param) {
          if (type) {
            this.getPageData(params)
          } else {
            this.getData(params)
          }
          // }
          item.config.timer = setInterval(() => {
            if (type) {
              this.getPageData(params)
            } else {
              this.getData(params)
            }
          }, 10 * 60 * 1000)
          break
        case 7:
          // if (param) {
          if (type) {
            this.getPageData(params)
          } else {
            this.getData(params)
          }
          // }
          item.config.timer = setInterval(() => {
            if (type) {
              this.getPageData(params)
            } else {
              this.getData(params)
            }
          }, 30 * 60 * 1000)
          break
        default:
          break
      }
    },
    // 处理图表返回数据
    formatChartData(data, item) {
      if (!isEmpty(data)) {
        // 图表有x轴数据时需要处理时
        if (['LineChartConfig', 'BarChartConfig', 'LineAndBarChartConfig'].includes(item.components)) {
          console.log(item.formatXAxisData, 'eee')
          item.option.xAxis.data = new Function(...item.formatXAxisData.arguments, item.formatXAxisData.value)(data)
        }
        // 图表有y轴据时需要处理时
        if (['BarChartConfig'].includes(item.components)) {
          // eslint-disable-next-line no-new-func
          item.option.yAxis.data = new Function(...item.formatXAxisData.arguments, item.formatXAxisData.value)(data)
        }
        // 雷达图特征数据处理(指示器)
        if (item.components === 'RadarChartConfig') {
          item.option.radar.indicator = new Function(
            ...item.formatIndicatorData.arguments,
            item.formatIndicatorData.value
          )(data)
        }
        // 自定义数据
        if (item.components === 'CustomChartConfig') {
          item.data = cloneDeep(data)
        } else {
          console.log(3333, item)
          if (item.components === 'LineChartConfig') {
            if (item.option.series && item.option.series.length > 0 && !item.option.series[0].markLineButton) {
              item.formatData.value = item.formatData.value.replace(/markLine=/g, 'markLine!==')
            }
          }
          // eslint-disable-next-line no-new-func
          item.option.series = new Function(...item.formatData.arguments, item.formatData.value)(data)
          // 设置图例名称
          for (let i = 0; i < item.option.series.length; i++) {
            if (item.config.sourceOption === 1) {
              // 选择数据模型
              if (['JadeJuefigureChartConfig'].includes(item.components)) {
                console.log('123')
              } else if (['LiquidFillChartConfig'].includes(item.components)) {
                // 水球图有数据要处理时
                // eslint-disable-next-line no-new-func
                // 水球图有数据要处理时
                // eslint-disable-next-line no-new-func
                item.option.value = Number(data[0][1].value)
                item.option.totalCustomValue = Number(data[0][0].value)
                item.option.series[0].data[0].value = Number(data[0][1].value) / Number(data[0][0].value)
                item.option.title.subtext = '当前60.345%'
                item.option.title.text = '目标90.918%'
                item.option.title.subtext = item.option.title.subtext.replace('60.345', Number(data[0][1].value))
                item.option.title.text = item.option.title.text.replace('90.918', Number(data[0][0].value))
                this.changeValue1 = true
                this.$emit('childFn1', this.changeValue1)
              } else if (['VerticalBarChartConfig'].includes(item.components)) {
                // 水柱图有数据要处理时
                // eslint-disable-next-line no-new-func
                // 水柱图有数据要处理时
                item.option.value = Number(data[0][0].value)
                item.option.totalCustomValue = Number(data[0][1].value)
                item.option.allTitle0 = data[0][1].allTitle
                item.option.allTitle1 = data[0][0].allTitle
                item.option.title.subtext = '当前60.345%\n\n目标90.918%'
                item.option.title.subtext =
                  data[0][0].allTitle +
                  Number(data[0][0].value) +
                  data[0][2].allSymbol +
                  '\n\n' +
                  data[0][1].allTitle +
                  Number(data[0][1].value) +
                  data[0][2].allSymbol
                this.changeValue = true
                this.$emit('childFn', this.changeValue)
              } else if (item.components === 'RadarChartConfig') {
                item.option.series[i].data[0].name =
                  item.config.condition.yAxis[i].dataType === 1
                    ? item.config.condition.yAxis[i].field
                    : item.config.condition.yAxis[i].measureName
              } else {
                if (item.components !== 'LineAndBarChartConfig') {
                  // item.option.series[i].data[0].name =
                  //   item.config.condition.yAxis[i].dataType === 1
                  //     ? item.config.condition.yAxis[i].field
                  //     : item.config.condition.yAxis[i].measureName
                }
              }
            } else {
              // 选择数据源
              if (item.components === 'RadarChartConfig') {
                item.option.series[i].data[0].name = item.config.condition.source.yAxis[i].field
              } else {
                if (item.components !== 'LineAndBarChartConfig') {
                  item.option.series[i].name = item.config.condition.source.yAxis[i].field
                }
              }
            }
          }
        }
      }
      return item
    },
    // 处理其他组件返回数据
    formatData(data, item) {
      let formatData = item.data
      // 处理翻牌器数据
      if (['FlipperConfig'].includes(item.components)) {
        if (isNaN(parseInt(formatData))) {
          return
        } else {
          formatData = parseInt(formatData).toString()
        }
      }
      // // 处理环形进度条数据
      // if (['CircularProgressBarConfig'].includes(item.components)) {
      //   console.log('5858585858', formatData)
      //   if (isNaN(parseFloat(formatData))) {
      //     return
      //   } else {
      //     formatData = parseInt(formatData)
      //   }
      // }
      item.option.data = formatData
    },
    async getPageDetail(iid) {
      const param = getUrlParam('param')
      const res = await JDATA_API.pageDetail({ iid, param })
      if (res.success) {
        const data = res?.data?.data?.pageBody || '{}'
        this.pageConfig = JSON.parse(data)
        this.page = JSON.parse(data)
        this.robotConfig = res?.data?.data?.quesSetting ? JSON.parse(res?.data?.data?.quesSetting) : {}
        this.$nextTick(() => {
          this.robotUrl = res.data.data.airobotUrl
          this.chatId = res.data.data.chatId
          this.wechatUrl = res.data.data.wechatUrl
          this.openQrCode()
        })
        // const { dragList } = this.pageConfig
        // this.$echarts.registerMap('china', china)
        // const { dragList } = this.pageConfig
        // for (let i = 0; i < dragList?.length; i++) {
        //   let item = dragList[i]
        //   const iid = item.iid
        //   let newId = ''
        //   if (window.jdataParams) {
        //     if (getWindowParam('id').indexOf('-') !== -1) {
        //       newId = this.$root.jcms_id
        //     } else {
        //       newId = getUrlParam('id')
        //     }
        //   } else {
        //     newId = getUrlParam('id')
        //   }
        //   this.iid = newId

        //   const index = i
        //   const param = getUrlParam('param')
        //   const params = {
        //     dataId: iid,
        //     pageId: this.iid,
        //     index: index,
        //     param: param
        //   }
        //   if (item?.components?.indexOf('ChartConfig') !== -1) {
        //     if (item?.config?.dataOption !== 3) {
        //       this.getPageData(params) // 页面刷新时调用定时器接口
        //     }
        //   }
        //   if (
        //     [
        //       'ListConfig',
        //       'TextConfig',
        //       'FlipperConfig',
        //       'PercentageIndicatorConfig',
        //       'CircularProgressBarConfig'
        //     ].includes(item?.components)
        //   ) {
        //     if (item?.config?.dataOption !== 3) {
        //       this.getData(params)
        //     }
        //   }
        // }
        const regionCode = getUrlParam('regionCode')
        setTimeout(() => {
          console.log('this.dragList---', this.dragList)
          this.dragList.forEach((e, i) => {
            if (e.components === 'PlacePickerConfig') {
              if (!e.option.show) {
                this.regionId = e.option.treeList && e.option.treeList.length > 0 ? e.option.treeList[0].value : ''
                e.option.treeValue = e.option.treeList && e.option.treeList.length > 0 ? e.option.treeList[0].value : ''
              } else {
                JDATA_API.getRegion({ pageId: iid, regionCode: regionCode }).then(res => {
                  if (res.success) {
                    this.regionId = res.data && res.data.length > 0 ? res.data[0].value : ''
                    e.option.treeList = res.data && res.data.length > 0 ? res.data : []
                    e.option.treeValue = res.data && res.data.length > 0 ? res.data[0].value : ''
                  }
                })
              }
            }
            if (e.components === 'DatePickerConfig') {
              this.cTime = e.option.cTime ? e.option.cTime.join('--') : ''
            }

            if (e?.components?.indexOf('ChartConfig') !== -1) {
              if (e?.config?.dataOption !== 3) {
                this.setDataInterval(e, i, true)
              }
            }
            if (
              [
                'ListConfig',
                'TextConfig',
                'FlipperConfig',
                'PercentageIndicatorConfig',
                'CircularProgressBarConfig',
                'HorizontalProgressBarConfig'
              ].includes(e?.components)
            ) {
              if (e?.config?.dataOption !== 3) {
                this.$nextTick(() => {
                  this.setDataInterval(e, i, false)
                })
              }
            }
          })
        }, 100)
      }
    },
    openQrCode() {
      this.webchatToken = new Date().getTime()
      this.connectWs()
    },
    //二维码连接ws
    connectWs() {
      if (this.wsClient) {
        this.wsClient.close()
      }
      const that = this
      const protocol = location.protocol === 'https:' ? 'wss://' : 'ws://'
      let urlHead = protocol + location.host + '/api-websocket'
      if (process.env.NODE_ENV === 'development') {
        urlHead = 'wss://zwfw.hanweb.com/api-websocket'
        // urlHead = 'ws://192.168.84.6:8098'
      }
      const url = `${urlHead}/jpaas-jdata-server/ws/interaction/${this.webchatToken}`
      // 初始化ws
      this.wsClient = new WebSocketClient({
        url: url,
        heartbeatInterval: 3000,
        reconnectInterval: 1000,
        heartbeat: true,
        reconnecting: true
      })
      this.wsClient.onMessage(event => {
        const data = JSON.parse(event.data)
        // console.log('wechat数据：', data)
        if (data.code === '202') {
          if (that.qrCodeTimer) {
            clearInterval(that.qrCodeTimer)
          }
          that.qrCodeTimer = setInterval(function() {
            that.refreshQr = true
            clearInterval(that.qrCodeTimer)
            that.wsClient.close()
          }, 5000)
        }
        if (data.code !== '202' && data.data.q) {
          if (that.isTalking) {
            that.$message.warning('当前问答正在进行中，请稍后再试！')
            return
          }
          that.resultText = ''
          that.question = data.data.q.split('&')[0]
          that.modelId = data.data.q.split('&')[1]
          that.initSse()
          setTimeout(() => {
            // const dragElement = document.querySelector('.draggable-box')
            // const height = dragElement.offsetHeight
            // const panel = document.querySelector('.drag-panel')
            // const rect = panel.getBoundingClientRect()
            // dragElement.style.left = (window.innerWidth - dragElement.offsetWidth) / 2 + 'px'
            // dragElement.style.bottom = (rect.height - height) / 2 + 'px'
          }, 10)
        }
      })
      this.wsClient.onOpen(() => {
        console.log('二维码ws连接成功')
        const origin = window.location.origin + '/api-gateway'
        const qrUrl = that.wechatUrl + `?id=${that.chatId}&t=${that.webchatToken}&origin=${origin}`
        // 生成二维码
        QRCode.toDataURL(qrUrl, { width: 120, margin: 1 }, (err, url) => {
          if (!err) {
            that.qrcodeUrl = url
            that.refreshQr = false
            that.loadingQr = false
            console.log('二维码地址---', qrUrl)
          }
        })
        that.qrCodeTimer = setInterval(function() {
          that.wsClient.close()
        }, 5000)
      })
      this.wsClient.onClose(() => {
        console.log('二维码ws断开')
        that.loadingQr = false
        that.refreshQr = true
        that.refreshQrCode()
        if (that.qrCodeTimer) {
          clearInterval(that.qrCodeTimer)
        }
      })
    },
    // 刷新二维码
    refreshQrCode() {
      this.loadingQr = true
      this.openQrCode()
    },
    //根据ws接收的问题调用ask接口
    initSse() {
      let textCont = ''
      const that = this
      that.isTalking = true
      this.sseClient = sseAPI.ask({
        data: {
          q: that.question,
          token: new Date().getTime(),
          chatId: that.chatId,
          extra: JSON.stringify({
            jdataModelId: that.modelId
          })
        },
        message(msg) {
          if (msg.type === 'message') {
            const data = msg.data
            console.log('sse数据：', data)
            if (data.flag === 'middle') {
              // that.question = ''
              if (that.closeRobotTimer) {
                clearInterval(that.closeRobotTimer)
              }
              textCont += data.content

              that.resultText = textCont
              setTimeout(() => {
                const contTop = document.querySelector('.floatBox') // 通过类名获取元素
                contTop.scrollTop = contTop.scrollHeight
              }, 10)
              // setTimeout(() => {
              //   const dragElement = document.querySelector('.draggable-box')
              //   const height = dragElement.offsetHeight
              //   const panel = document.querySelector('.drag-panel')
              //   const rect = panel.getBoundingClientRect()
              //   dragElement.style.left = (window.innerWidth - dragElement.offsetWidth) / 2 + 'px'
              //   dragElement.style.bottom = (rect.height - height) / 2 + 'px'
              // }, 20)
            }
            if (data.flag === 'end' && that.resultText === '') {
              that.resultText = '很抱歉，暂时没有内容生成。'
            }
            if (data.flag === 'end') {
              that.isTalking = false
              setTimeout(() => {
                const dragElement = document.querySelector('.floatBox')
                const height = dragElement.offsetHeight
                const scrollHeight = dragElement.scrollHeight
                if (scrollHeight - 40 > height) {
                  setTimeout(() => {
                    const contTop = document.querySelector('.floatBox') // 通过类名获取元素
                    contTop.scrollTop = 0
                    that.createScrollAnimation()
                  }, 1000)
                } else {
                  dragElement.style.animation = 'none'
                  dragElement.style.transform = 'translateY(0)'
                }
                // const bottomY = Number(dragElement.style.bottom.split('px')[0])
                // const inputY = height + bottomY + 10
                // const inputElement = document.querySelector('.voice-input')
                // if (inputElement) {
                //   inputElement.style.bottom = inputY + 'px'
                // }
              }, 100)
              that.closeRobotTimer = setInterval(function() {
                that.resultText = ''
                that.question = ''
              }, 120000)
            }
          }
        }
      })
    },
    createScrollAnimation() {
      const dragElement = document.querySelector('.floatBox')
      const contentElement = dragElement.children[0]

      // 重置样式确保从初始位置开始
      contentElement.style.transform = 'translateY(0)'

      let start
      const duration = 10000 // 总滚动时间
      let isResetting = false

      function step(timestamp) {
        if (!start) start = timestamp

        const progress = (timestamp - start) % duration
        const progressRatio = progress / duration

        // 获取元素高度信息
        const containerHeight = dragElement.offsetHeight
        const contentHeight = contentElement.scrollHeight

        // 计算最大可滚动距离（内容高度 - 容器高度 + 底部间距）
        const maxScrollDistance = Math.max(0, contentHeight - containerHeight + 50)

        // 如果内容高度小于等于容器高度，不需要滚动
        if (maxScrollDistance <= 0) {
          contentElement.style.transform = 'translateY(0)'
          return
        }

        // 计算当前滚动位置
        const translateY = -progressRatio * maxScrollDistance

        // 检查是否需要重置（滚动到底部30px位置）
        if (-translateY >= maxScrollDistance - 60 && !isResetting) {
          isResetting = true

          // 平滑重置到起始位置
          setTimeout(() => {
            start = timestamp
            isResetting = false
            contentElement.style.transition = 'none'
            contentElement.style.transform = 'translateY(0)'
            dragElement.style.paddingTop = '0px'

            // 下一帧重新开始动画
            setTimeout(() => {
              requestAnimationFrame(newTimestamp => {
                start = newTimestamp
                contentElement.style.transition = ''
                step(newTimestamp)
              })
            }, 2000)
          }, 1000) // 短暂延迟后重置

          return
        }

        contentElement.style.transform = `translateY(${translateY}px)`

        if (!isResetting) {
          requestAnimationFrame(step)
        }
      }

      requestAnimationFrame(step)
    },
    goRobot() {
      if (this.robotUrl) {
        window.open(this.robotUrl)
      }
    },
    findItemById(items, targetIid) {
      // 遍历当前层级的每一项
      for (const item of items) {
        // 如果当前项的iid匹配，直接返回
        if (item.iid === targetIid) {
          return item
        }

        // 检查是否有components为TabsConfig且有tabList的情况
        if (item.components === 'TabsConfig' && item.option && item.option.tabList) {
          // 遍历每个tab
          for (const tab of item.option.tabList) {
            // 如果tab有dragList，递归查找
            if (tab.dragList && tab.dragList.length > 0) {
              const found = this.findItemById(tab.dragList, targetIid)
              if (found) return found
            }
          }
        }

        // 检查是否有普通的dragList
        if (item.dragList && item.dragList.length > 0) {
          const found = this.findItemById(item.dragList, targetIid)
          if (found) return found
        }
      }

      // 如果遍历完都没找到，返回null
      return null
    },
    // 获取图表数据
    getPageData(params) {
      return JDATA_API.getCustom(params).then(res => {
        if (res?.success) {
          // console.log(this.dragList[params.index].components, 111)
          if (res?.data?.echartData) {
            if (typeof params.index === 'string') {
              let targetItem = this.findItemById(this.dragList, params.index)
              console.log('targetItem', targetItem)
              targetItem.data = JSON.parse(JSON.stringify(res.data.echartData))
              targetItem = this.formatChartData(res.data.echartData, targetItem)
            } else {
              if (this.dragList[params.index].components === 'JadeJuefigureChartConfig') {
                res.data.echartData.forEach(item => {
                  item.forEach(it => {
                    it.value = Number(it.value)
                  })
                })
                if (res.data.echartData[0].length > 5) {
                  res.data.echartData[0] = res.data.echartData[0].slice(0, 5)
                }
                this.dragList[params.index].data = res.data.echartData
                this.dragList[params.index] = this.formatChartData(res.data.echartData, this.dragList[params.index])

                // console.log('res.data.echartData: ', res.data.echartData, this.dragList[params.index])
                // this.chartData = res.data.echartData // 静态数据
              } else if (this.dragList[params.index].components === 'CustomDialChartConfig') {
                // 自定义表盘
                // 自定义表盘有数据要处理时
                this.dragList[params.index].option.value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[0].axisLine.lineStyle.color[0][0] =
                  Number(res.data.echartData[0][0].value) / 100
                this.dragList[params.index].option.series[2].value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[2].data[0].label.normal.formatter =
                  Number(res.data.echartData[0][0].value) + this.dragList[params.index].option.allSymbol
              } else if (this.dragList[params.index].components === 'ProgressDashboardChartConfig') {
                // 进度仪表盘
                // 进度仪表盘有数据要处理时
                this.dragList[params.index].option.value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[0].axisLine.lineStyle.color[0][0] =
                  Number(res.data.echartData[0][0].value) / this.dragList[params.index].option.totalCustomValue
                this.dragList[params.index].option.series[0].data[0].value = Number(res.data.echartData[0][0].value)
              } else if (this.dragList[params.index].components === 'VerticalBarChartConfig') {
                // 水柱图
                // 水柱图有数据要处理时
                this.dragList[params.index].option.value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[1].data[0] = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[2].data[0] = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[4].data[0] = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.title.subtext = '当前60.345%\n\n目标90.918%'

                this.dragList[params.index].option.title.subtext =
                  this.dragList[params.index].option.allTitle1 +
                  Number(res.data.echartData[0][0].value).toFixed(this.dragList[params.index].option.decimalNum) +
                  this.dragList[params.index].option.allSymbol +
                  '\n\n' +
                  this.dragList[params.index].option.allTitle0 +
                  this.dragList[params.index].option.totalCustomValue +
                  this.dragList[params.index].option.allSymbol
                this.changeValue = true
                this.$emit('childFn', this.changeValue)
              } else if (this.dragList[params.index].components === 'LiquidFillChartConfig') {
                // 水球图
                this.dragList[params.index].data[0][1].value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.value = Number(res.data.echartData[0][0].value)
                this.dragList[params.index].option.series[0].data[0].value =
                  Number(res.data.echartData[0][0].value) / this.dragList[params.index].option.totalCustomValue

                this.dragList[params.index].option.title.subtext = '当前60.345%'
                this.dragList[params.index].option.title.subtext = this.dragList[
                  params.index
                ].option.title.subtext.replace(
                  '60.345',
                  Number(res.data.echartData[0][0].value).toFixed(this.dragList[params.index].option.decimalNum)
                )
                this.changeValue1 = true
                this.$emit('childFn1', this.changeValue1)
              } else {
                // this.dragList[params.index] = JSON.parse(
                //   JSON.stringify(this.formatChartData(res.data.echartData, this.dragList[params.index]))
                // )
                this.dragList[params.index].data = JSON.parse(JSON.stringify(res.data.echartData))
                this.dragList[params.index] = this.formatChartData(res.data.echartData, this.dragList[params.index])
              }
            }
            this.count++
            return Promise.resolve(res)
          }
        }
        // if (res?.success) {
        //   // 静态数据保存时
        //   console.log(110)
        //   console.log('this.activeObject.config: ', this.dragList)
        //   if (this.activeObject.config.dataOption === 3) {
        //     console.log(11)
        //     if (this.activeObject.components === 'LiquidFillChartConfig') {
        //       // 水球图
        //       this.chartData[0][1].value = Number(res.data.echartData[0][0].value)
        //       this.activeObject.data[0][1].value = Number(res.data.echartData[0][0].value)
        //       this.activeObject.option.value = Number(res.data.echartData[0][0].value)
        //       this.activeObject.option.title.subtext = '当前60.345%'
        //       this.activeObject.option.title.subtext = this.activeObject.option.title.subtext.replace(
        //         '60.345',
        //         Number(res.data.echartData[0][0].value)
        //       )
        //       this.activeObject.option.series[0].data[0].value = Number(res.data.echartData[0][0].value) / 90.918
        //       this.changeValue1 = true
        //       this.$emit('childFn1', this.changeValue1)
        //     } else if (this.activeObject.components === 'GaugeChartConfig') {
        //       // 仪表盘
        //       // console.log('仪表盘', this.option)
        //       this.activeObject.data = [this.option.series[this.option.series.length - 1].data]
        //       this.chartData = [this.option.series[this.option.series.length - 1].data]
        //     } else if (this.activeObject.components === 'RadarChartConfig') {
        //       // 雷达
        //       // console.log('静态数据', this.option)
        //       const arrList = []
        //       let name = ''
        //       let value = ''
        //       const nameList = []
        //       const valueList = []
        //       for (let i = 0; i < this.option.series.length; i++) {
        //         this.option.series[i].data[0].name = this.option.radar.indicator
        //       }
        //       // console.log('雷达', this.option.series)
        //       this.option.series.forEach(item => {
        //         item.data[0].value.forEach(item => {
        //           // console.log('值', item)
        //           value = item
        //           valueList.push(value)
        //         })
        //       })
        //       this.option.series.forEach(item => {
        //         item.data[0].name.forEach(item => {
        //           name = item.text
        //           nameList.push(name)
        //         })
        //       })
        //       // console.log('组合的数组', valueList, nameList)
        //       for (let i = 0; i < valueList.length; i++) {
        //         arrList.push({ name: nameList[i], value: valueList[i] })
        //       }
        //       var groupedArray = this.group(arrList, 5)
        //       // console.log('新的两个数组', groupedArray)
        //       this.activeObject.data = groupedArray
        //       this.chartData = groupedArray
        //     } else {
        //       if (!this.lineAndBar) {
        //         // console.log('静态数据', this.option.series[0].data)
        //         this.activeObject.data = [this.option.series[0].data]
        //         this.chartData = [this.option.series[0].data]
        //       } else {
        //         // const chartDataLeft = []
        //         // for (var i = 0; i < this.chartData[0].length; i++) {
        //         //   chartDataLeft.push(this.option.series[i])
        //         // }
        //       }
        //     }
        //   } else {
        //     console.log(22)
        //     this.dragList[params.index] = JSON.parse(
        //       JSON.stringify(this.formatChartData(res.data.echartData, this.dragList[params.index]))
        //     )
        //     console.log(2222222222)
        //     this.dragList[params.index].data = JSON.parse(JSON.stringify(res.data.echartData))
        //     this.dragList[params.index] = this.formatChartData(res.data.echartData, this.dragList[params.index])
        //     this.count++
        //     return Promise.resolve(res)
        //   }
        // }
      })
    },
    // 获取其他数据
    getData(params) {
      return JDATA_API.getData(params).then(res => {
        if (res?.success) {
          // 选择为行时处理返回数据格式为横向
          const data = res.data.data
          if (
            this.dragList[params.index].components === 'ListConfig' &&
            this.dragList[params.index].config.rocOption === 1
          ) {
            const rowsArray = data[0].map((col, i) => {
              return data.map(row => {
                return row[i]
              })
            })
            this.dragList[params.index].option.data = rowsArray
          } else if (
            this.dragList[params.index].components === 'TextConfig' ||
            this.dragList[params.index].components === 'FlipperConfig' ||
            this.dragList[params.index].components === 'PercentageIndicatorConfig'
          ) {
            this.dragList[params.index].option.data = data?.[0]?.[0] || ''
          } else if (
            this.dragList[params.index].components === 'CircularProgressBarConfig' ||
            this.dragList[params.index].components === 'HorizontalProgressBarConfig'
          ) {
            // 处理环形进度条数据
            this.dragList[params.index].option.data = parseFloat(data?.[0]?.[0]) || 0
          } else {
            this.dragList[params.index].option.data = data || []
          }
          return Promise.resolve(res.success)
        }
      })
    },
    //改变地区
    onChangePlace(value) {
      this.dragList.forEach(item => {
        if (item.config && item.config.timer) {
          clearInterval(item.config.timer)
        }
      })
      this.regionId = value
      for (let i = 0; i < this.dragList?.length; i++) {
        let item = this.dragList[i]
        if (item?.components?.indexOf('ChartConfig') !== -1) {
          if (item?.config?.dataOption !== 3) {
            this.setDataInterval(item, i, true)
          }
        }
        if (
          [
            'ListConfig',
            'TextConfig',
            'FlipperConfig',
            'PercentageIndicatorConfig',
            'CircularProgressBarConfig',
            'HorizontalProgressBarConfig'
          ].includes(item?.components)
        ) {
          if (item?.config?.dataOption !== 3) {
            this.$nextTick(() => {
              this.setDataInterval(item, i, false)
            })
          }
        }
        //渲染tab内的图表
        if (item.components === 'TabsConfig') {
          this.refreshTab(item.option.tabList)
        }
      }
    },
    //改变时间
    onChangeDate(value) {
      console.log(444, value)
      this.dragList.forEach(item => {
        if (item.config && item.config.timer) {
          clearInterval(item.config.timer)
        }
      })
      this.cTime = value && value[0] !== '' ? value.join('--') : ''
      for (let i = 0; i < this.dragList?.length; i++) {
        let item = this.dragList[i]
        if (item?.components?.indexOf('ChartConfig') !== -1) {
          if (item?.config?.dataOption !== 3) {
            this.setDataInterval(item, i, true)
          }
        }
        if (
          [
            'ListConfig',
            'TextConfig',
            'FlipperConfig',
            'PercentageIndicatorConfig',
            'CircularProgressBarConfig',
            'HorizontalProgressBarConfig'
          ].includes(item?.components)
        ) {
          if (item?.config?.dataOption !== 3) {
            this.$nextTick(() => {
              this.setDataInterval(item, i, false)
            })
          }
        }
        //渲染tab内的图表
        if (item.components === 'TabsConfig') {
          this.refreshTab(item.option.tabList)
        }
      }
    },
    refreshTab(list) {
      list.forEach(e => {
        if (e.dragList && e.dragList.length > 0) {
          e.dragList.forEach(item => {
            if (item.config && item.config.timer) {
              clearInterval(item.config.timer)
            }
          })
          for (let i = 0; i < e.dragList?.length; i++) {
            let item = e.dragList[i]
            if (item?.components?.indexOf('ChartConfig') !== -1) {
              if (item?.config?.dataOption !== 3) {
                this.setDataInterval(item, item.iid, true)
              }
            }
            if (
              [
                'ListConfig',
                'TextConfig',
                'FlipperConfig',
                'PercentageIndicatorConfig',
                'CircularProgressBarConfig',
                'HorizontalProgressBarConfig'
              ].includes(item?.components)
            ) {
              if (item?.config?.dataOption !== 3) {
                this.$nextTick(() => {
                  this.setDataInterval(item, item.iid, false)
                })
              }
            }
            if (item.components === 'TabsConfig') {
              this.refreshTab(item.option.tabList)
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.drag-panel {
  transform-origin: 0 0;
  width: 100%;
  border-top: none;
  position: relative;
  .robot-img {
    position: fixed;
    bottom: 20%;
    right: -40px;
    cursor: pointer;
    z-index: 999;
    width: 80px;
  }
  .robot-img:hover {
    right: 5px;
  }
  // .voice-input {
  //   // width: 312px;
  //   background: #000a2bcc;
  //   border-radius: 20px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   padding: 10px 20px;
  //   position: fixed;
  //   bottom: 20px;
  //   right: 20px;
  //   font-weight: 400;
  //   font-size: 14px;
  //   color: #fff;
  //   border: 1px solid #82bcff;
  //   z-index: 999;
  //   .voice-img {
  //     width: 17px;
  //     height: 23px;
  //     margin-left: 5px;
  //   }
  // }
  .qrcode-img {
    width: 100px;
    height: 100px;
    position: fixed;
    top: 5px;
    right: 5px;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
    .qr-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffffd6;
    }
  }
}
.background-layer {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
}
.spining {
  left: 50%;
  top: 50%;
  transform: translateX(-50%, -50%);
  position: absolute;
}
.custome-drag {
  border: none;
  touch-action: none;
  position: absolute;
  box-sizing: border-box;
}
</style>
